import { MutationTree } from "vuex";
import { IReceptionState } from "./reception-state.store";
import * as types from "./reception-types.store";
import { ActivityStatus } from "../../common/enums";
import { IReceptionSectionListingViewModel, IReceptionDetailViewModel, ReceptionParameter } from "../../models/reception";
import { Pagination } from "../../models/generic";
export const mutations: MutationTree<IReceptionState> = {
  [types.RECEPTION_GET_RECEPTIONS_LOADING]: (state: IReceptionState, activityStatus: ActivityStatus) => {
    state.receptionsSource.activityStatus = activityStatus;
  }
  , [types.RECEPTION_GET_RECEPTION_LOADING]: (state: IReceptionState, activityStatus: ActivityStatus) => {
    state.receptionSource.activityStatus = activityStatus;
  }
  , [types.RECEPTION_GET_RECEPTION_SECTIONS_LOADING]: (state: IReceptionState, activityStatus: ActivityStatus) => {
    state.receptionSections.activityStatus = activityStatus;
  }

  , [types.RECEPTION_GET_RECEPTIONS]: (state: IReceptionState, payload: {
    activityStatus: ActivityStatus,
    merge?: boolean,
    receptions: any[],
    pagination?: any
  }) => {
    if (payload.merge === false) {
      state.receptionsSource.data = payload.receptions;
    }
    else {
      const receptions = state.receptionsSource.data || [];
      const uniqueReceptions = payload.receptions.filter((item) => {
        return receptions.findIndex(t => t.id === item.id) === -1;
      });
      state.receptionsSource.data = receptions.concat(uniqueReceptions);
    }

    state.receptionsSource.activityStatus = payload.activityStatus;

    if (payload.pagination) {
      state.pagination = payload.pagination;
    }

  }
  , [types.RECEPTION_GET_RECEPTION]: (state: IReceptionState,
    detail: IReceptionDetailViewModel) => {
    state.receptionSource = {
      activityStatus: ActivityStatus.Loaded,
      detail: detail
    };
  }
  , [types.RECEPTION_GET_RECEPTION_SECTIONS]: (state: IReceptionState,
    data: IReceptionSectionListingViewModel[]) => {

    state.receptionSections = {
      activityStatus: ActivityStatus.Loaded,
      data: data
    };
  }
  , [types.RECEPTION_GET_SECTION]: (state: IReceptionState,
    data: IReceptionSectionListingViewModel[]) => {

    state.receptionSections = {
      activityStatus: ActivityStatus.Loaded,
      data: data
    };
  }
  , [types.RECEPTION_SET_VALUE_BY_FIELD]: (state: IReceptionState,
    payload: { [key: string]: any }) => {
    state.receptionParameter = {
      ...state.receptionParameter,
      ...payload
    };
  }
  , [types.RECEPTION_RESET_RECEPTIONS]: (state: IReceptionState, payload: {
    activityStatus: ActivityStatus,
    merge?: boolean,
    tickets: any[],
    pagination?: any
  }) => {
    state.receptionParameter = new ReceptionParameter();
    state.pagination = new Pagination({ total: 0, limit: 0, skip: 0 });
    state.receptionsSource.data = [];
    state.receptionsSource.activityStatus = ActivityStatus.NoActivity;
  }
  , [types.RECEPTION_SET_LOADER_STATE] : (state: IReceptionState, payload: { key: string, value: boolean }) => {
     state.loaders= new Map([
       ...state.loaders,
       [payload.key,payload.value]
     ])
  }
} 


// WEBPACK FOOTER //
// ./src/store/reception/reception-mutations.store.ts